export const duneApiKeyHeaderKey = "X-DUNE-API-KEY";

export const duneApiKeyHeaderValue = "GfV36u6M9HZ3JOx03n4vxr2NZXBiGdUH";

export const duneQueryId = 3_495_214;
